import React from 'react'
import CardsBoot from './cardsBoot'
import "./index.css"
export default function Skill() {
  return (
    <div className="skills-container" id="skills">
        <h1 className='text-center'>Skills</h1>
        <CardsBoot/>
    </div>
  )
}
